import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormReceivedView } from './views/form-received/form-received.component';
import { FormView } from './views/form/form.component';
import { LoginView } from './views/login/login.component';
import { VippsComponent } from './views/vipps/vipps.component';


const routes: Routes = [
  {path: '', component: LoginView},
  {path: 'vipps', component: VippsComponent},
  {
    path: 'form',
    loadChildren: () => import('./views/form/form.module').then(m => m.FormModule)
  },
  {path: 'form-received', component: FormReceivedView}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
